import { twMerge } from '@dynamika-shared/utils/twMerge';
import { capitalize } from 'lodash';
import { ReactNode } from 'react';
import { QueryStatus } from '@restore/queries/queries.types';
import { STATUS_QUERY_COLORS } from '@components/Queries/constants';


export const StatusQuery = ({
  status,
  children,
}: {
  status: QueryStatus;
  children?: ReactNode;
}) => {
  const colorValue = STATUS_QUERY_COLORS[status];

  return (
    <span
      className={twMerge(
        colorValue,
        'text-1424 whitespace-nowrap rounded-xl px-1.5 py-0.5 w-auto'
      )}
    >
      {status
        ?.split('_')
        ?.map(text => {
          if (text.toLowerCase() === 'iag'){
            return text.toUpperCase();
          } else {
            return capitalize(text);
          }
        })
        ?.join(' - ')}
      {children}
    </span>
  );
};
